import {TweenMax} from 'gsap';

const SizesUtils = require('../../viscomjs/utils/SizesUtils');

const _activateItem = (d, i) => {
    if (!d._hasItems) return;
    if (i < 0 || i > d._items.length - 1) return;
    _deactivateCurItem(d);
    d._activeIndex = i;
    d._items[i].dataset.active = true;
}

const _deactivateCurItem = d => {
    if (d._activeIndex < 0) return;
    _deactivateItem(d, d._activeIndex);
}

const _deactivateItem = (d, i) => {
    if (!d._hasItems) return;
    // if (i < 0 || i > d._items.length - 1) return;
    d._items[i].dataset.active = false;
}

function init() {
    if (this._initiated) return;

    this._items = [...this.el.querySelectorAll('[data-risk-id]')];
    this._yRefs = this._items.map(el => el.querySelector('[data-risk-marker]'));
    this._valueEls = this._items.map(el => el.querySelector('[data-value]'));
    this._hasItems = this._items.length > 0;
    _activateItem(this, 0);

    this.el.style.pointerEvents = 'none';
    this._initiated = true;

    return this;
}

function show() {
    this.el.classList.remove('deactivate');

    TweenMax.killDelayedCallsTo(_show);
    TweenMax.killDelayedCallsTo(_show2);
    TweenMax.killDelayedCallsTo(_shown);
    TweenMax.delayedCall(0.01, _show, [], this);

    return this;
}

function _show() {
    this.el.classList.remove('deactivate');
    this.el.classList.add('activate');

    TweenMax.killDelayedCallsTo(_show2);
    TweenMax.killDelayedCallsTo(_shown);
    TweenMax.delayedCall(1.6, _show2, [], this);

    return this;
}

const _show2 = function () {
    this.el.classList.remove('deactivate');
    this.el.classList.add('active');
    TweenMax.killDelayedCallsTo(_shown);
    TweenMax.delayedCall(0.01, _shown, [], this);
};

const _shown = function () {
    this.el.classList.remove('deactivate');
    this.el.classList.remove('activate');
};

function hide() {
    TweenMax.killDelayedCallsTo(_shown);
    this.el.classList.remove('activate');
    this.el.classList.remove('active');
    this.el.classList.add('deactivate');
    return this;
}

function destroy() {

    return this;
}

function enable() {
    if (!this._initiated) return;
    this.el.style.pointerEvents = 'all';
    return this;
}

function disable() {
    if (!this._initiated) return;
    this.el.style.pointerEvents = 'none';
    return this;
}

function _showItem(index) {
    _activateItem(this, index);
}

function _setItemsValues(arr) {
    if (!this._hasItems) return;
    this._valueEls.forEach((el, i) => {
        el.innerHTML = arr[i] + '%'
    })
}

function _selectItem(i, b) {
    if (!this._hasItems) return;
    if (i < 0 || i > this._items.length - 1) return;
    this._items[i].dataset.selected = b;
}

function _getItemRefY(i) {
    if (!this._hasItems) return 0;
    if (i < 0 || i > this._yRefs.length - 1) return 0;
    const el = this._yRefs[i];
    if (!el) return 0;
    return el.getBoundingClientRect().top - SizesUtils.winOffsetHeight() / 2;
}

module.exports = el => {
    const Controller = {
        el: el,
        _activeIndex: -1
    };

    Controller.init = init.bind(Controller);
    Controller.enable = enable.bind(Controller);
    Controller.disable = disable.bind(Controller);
    Controller.show = show.bind(Controller);
    Controller.hide = hide.bind(Controller);
    Controller.destroy = destroy.bind(Controller);
    Controller.selectItem = _selectItem.bind(Controller);
    Controller.showItem = _showItem.bind(Controller);
    Controller.setItemsValues = _setItemsValues.bind(Controller);
    Controller.getItemRefY = _getItemRefY.bind(Controller);

    return Controller;
};


// WEBPACK FOOTER //
// ./js/viscom/kaspersky/risksOverview/DetailsSectionController.js